import React from "react";
import styles from "../../../assets/css/modules/containers/outer-primary-container.css";

export default function(props) {
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <div className={styles.containerShadow}>{props.children}</div>
        </div>
      </div>
    </div>
  );
}
